import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

// 学習単元一覧取得
export namespace ApiTaSf030 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        subjectId: string // 教科ID
        grade: number // 学年
        subunitType: number // 単元区分
        courseId: string // コースID
        planId?: string // プランID（Aコースの場合、必須）
      }
    }

    // API Response
    export interface LearningUnitNode {
      unitSubunitId: string // 配信単位単元ID
      isDeliveredFlg: boolean // 配信済フラグ
      deliveryMonth: string // 月号
      subunitsName: string // 単元名
      effortStatus: string // 取組状況
      isTestPiecesFlg: boolean // テストコマフラグ
      correctionsStatus: string | null // 添削ステータス
      testScore: string | null // テスト得点
    }
    export interface Response {
      learningUnitList: LearningUnitNode[] // 学習単元一覧
    }

    // API Path
    export const path: string = '/ta/units'
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        learningUnitList: [
          {
            unitSubunitId: '',
            isDeliveredFlg: false,
            deliveryMonth: '',
            subunitsName: '',
            effortStatus: '',
            isTestPiecesFlg: false,
            correctionsStatus: '',
            testScore: '',
          },
        ],
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
